import { LessonPlan } from '@/common/types/lessonPlan';
import {
  CopySimpleIcon,
  DotsThreeVerticalIcon,
  PencilSimpleIcon,
  TrashIcon,
} from '@phosphor-icons/react';
import { Button } from '@shadcn/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@shadcn/components/dropdown-menu';
import { TableCell, TableRow } from '@shadcn/components/table';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface LessonPlansTableRowProps {
  lessonPlan: LessonPlan;
  onCopy: () => void;
  onConfirmDelete: () => void;
}

export default function LessonPlansTableRow({
  lessonPlan,
  onCopy,
  onConfirmDelete,
}: LessonPlansTableRowProps) {
  const navigate = useNavigate();
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  function handleNavigateToLessonPlan() {
    navigate(`/dashboard/lessonplans/${lessonPlan.id}`);
  }

  return (
    <TableRow className="cursor-pointer" onClick={handleNavigateToLessonPlan}>
      <TableCell>
        <div className="flex items-center gap-3 font-medium">
          {lessonPlan.name}
        </div>
      </TableCell>
      <TableCell className="text-neutral-500">
        {dayjs(lessonPlan.updatedAt).fromNow()}
      </TableCell>
      <TableCell className="flex justify-end">
        <DropdownMenu open={isDropdownOpen} onOpenChange={setDropdownOpen}>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              className="p-1/2"
              onClick={(e) => e.stopPropagation()}
            >
              <DotsThreeVerticalIcon size={24} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent onClick={(e) => e.stopPropagation()}>
            <DropdownMenuLabel>{lessonPlan.name}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="flex gap-2"
              onClick={() => {
                setDropdownOpen(false);
                handleNavigateToLessonPlan();
              }}
            >
              <PencilSimpleIcon weight="bold" size={16} /> Edit
            </DropdownMenuItem>
            <DropdownMenuItem
              className="flex gap-2"
              onClick={() => {
                setDropdownOpen(false);
                onCopy();
              }}
            >
              <CopySimpleIcon weight="bold" size={16} /> Make a copy
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="flex gap-2 text-red-600"
              onClick={() => {
                setDropdownOpen(false);
                onConfirmDelete();
              }}
            >
              <TrashIcon weight="bold" size={16} /> Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </TableCell>
    </TableRow>
  );
}
